class HeaderDrawer extends HTMLElement {
    constructor(){
        super();

        this.btn = {
            el: this.querySelector('.hamburger-icon'),
            lineOne: this.querySelector('.hamburger-icon div:nth-child(1)'),
            lineTwo: this.querySelector('.hamburger-icon div:nth-child(2)'),
            lineThree: this.querySelector('.hamburger-icon div:nth-child(3)')
        };

        this.menuDrawer = {
            el: this.querySelector('.menu-drawer__container'),
            linkItems: this.querySelectorAll('.menu-drawer__container li > div')
        };

        this.animate = gsap.timeline({
            paused: true,
            reversed: true
        });

        this.animation();
        this.eventListeners();
    }

    animation(){
            this.animate.set(this.menuDrawer.linkItems, {
                display: 'block'
            })

            this.animate.to(this.btn.lineOne, {
                y: 9,
                rotate: 45,
            }, 0)

            this.animate.to(this.btn.lineTwo, {
                xPercent: -100,
                autoAlpha: 0,
            }, 0)

            this.animate.to(this.btn.lineThree, {
                y: -9,
                rotate: -45,
            }, 0)

            this.animate.fromTo(this.menuDrawer.el, {
                display: 'none',
                duration: 1.4,
                ease: 'power4.inOut',
                height: 0,
            }, {
                display: 'block',
                height: '100%'
            }, 0.15)

            this.animate.from(this.menuDrawer.linkItems, {
                yPercent: 130,
                stagger: 0.19,
                duration: 1.6,
                ease: 'power3.inOut'
            }, 0.10)
    }

    eventListeners(){
        this.btn.el.addEventListener('click', ()=> {
            this.animate.reversed() ? this.animate.play() : this.animate.reverse();
        })

        //when hit escape
        document.addEventListener('keydown', (e)=> {
            if(e.keyCode === 27){
                this.animate.reverse();
            }
        })
    }
}

customElements.define('header-drawer', HeaderDrawer);